import React, { lazy } from "react";

const Component1 = lazy(() => import("./1.js"));
const Component2 = lazy(() => import("./2.js"));
const Component3 = lazy(() => import("./3.js"));
const Component4 = lazy(() => import("./4.js"));
const Component5 = lazy(() => import("./5.js"));
const Component6 = lazy(() => import("./6.js"));
const Component7 = lazy(() => import("./7.js"));
const Component8 = lazy(() => import("./8.js"));
const Component9 = lazy(() => import("./9.js"));
const Component10 = lazy(() => import("./10"));
const Component11 = lazy(() => import("./11"));
const Component12 = lazy(() => import("./12"));
const Component13 = lazy(() => import("./13"));
const Component14 = lazy(() => import("./14"));
const Component15 = lazy(() => import("./15"));
const Component16 = lazy(() => import("./16"));

export default {
  FOOTER_1: Component1,
  FOOTER_2: Component2,
  FOOTER_3: Component3,
  FOOTER_4: Component4,
  FOOTER_5: Component5,
  FOOTER_6: Component6,
  FOOTER_7: Component7,
  FOOTER_8: Component8,
  FOOTER_9: Component9,
  FOOTER_10: Component10,
  FOOTER_11: Component11,
  FOOTER_12: Component12,
  FOOTER_13: Component13,
  FOOTER_14: Component14,
  FOOTER_15: Component15,
  FOOTER_16: Component16,
};
